import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './meeting.types';
import * as constants from './meeting.constants';

export const storeMeeting = generateStoreResourceAction<types.IMeeting>(constants.STORE_MEETING);
export const clearMeeting = generateClearResourceAction(constants.CLEAR_MEETING);
